import React from "react";
import classNames from "classnames";
import styles from "./BurgerButton.module.scss";

interface BurgerButtonProps {
  color?: string;
  size?: number;
  onClick?: () => void;
  className?: string;
  isTablet?: boolean;
  isSidebarOpen?: boolean;
}

export const BurgerButton: React.FC<BurgerButtonProps> = ({
  color = "currentColor",
  size = 24,
  onClick,
  className = "",
  isSidebarOpen = false,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
      className={classNames(className, styles.buttonContainer, {
        [styles.open]: isSidebarOpen,
      })}
    >
      <line
        x1="3"
        y1={isSidebarOpen ? "12" : "6"}
        x2="21"
        y2={isSidebarOpen ? "12" : "6"}
        className={classNames(styles.line1, {
          [styles.open]: isSidebarOpen,
        })}
      />
      <line
        x1="3"
        y1="12"
        x2="21"
        y2="12"
        className={classNames(styles.line2, {
          [styles.open]: isSidebarOpen,
        })}
      />
      <line
        x1="3"
        y1={isSidebarOpen ? "12" : "18"}
        x2="21"
        y2={isSidebarOpen ? "12" : "18"}
        className={classNames(styles.line3, {
          [styles.open]: isSidebarOpen,
        })}
      />
    </svg>
  );
};

export default BurgerButton;
